<template>
  <div>
    <div
      class="dev-left-bg"
      style="padding-right: -15px;"
    >
      <div class="dev-title-jks">
        <span class="dev-title-jks_test">建筑监控室</span>
      </div>

      <div class="monitor_center_box-body">
        <div class="dev-top-fy">
          <el-checkbox-group
            :value="checkBoxSelect"
          >
            <el-checkbox-button
              v-for="item in pageShowName"
              :key="item.key"
              :label="item.key"
              :class="{
                'checkBoxSelected1': pageCurrent === item.key
              }"
              @change="handleCurrentChange(item.key)"
            >
              {{ item.value }}
            </el-checkbox-button>
          </el-checkbox-group>
        </div>
        <div class="dev-center">
          <div
            v-for="item in filterDwList"
            :key="item.id"
            class="dev-center_item"
            :class="{
              'dev-center_item_fire': item.hjflag === 'Y',
            }"
            @click="changeJzw(item.botid,item.code)"
          >
            <div
              :class="{
                'dev-onClick-item': activeMonitoringRoom === item.code,
                'dev-offline-item': item.zjOffline > 0
              }"
              class="dev-center_item_body"
            >
              <img
                class="dev-center_item_body_img"
                :src="`/images/newscreen/icon/buiding.png`"
              >
              <div style="margin-left:10px">
                {{ item.name }} {{ item.dhWxygNum ? '（' + item.dhWxygNum + '）' : '' }}
              </div>
            </div>
            <div class="dev-center_item_xhx"/>
          </div>
        </div>
        <div
          v-if="!activeMonitoringRoom && loginUser ==='qcxz'"
          class="div-gzsb-jl"
          @click="handleGzsbjl()"
        >
          <img
            src="/monitor/images/tj/gzsbjl.svg"
            style="width: 18px;height: 18px;margin-right: 5px;"
          >

          {{ showGzsbjl ? '关闭' : '查看' }}故障设备报修记录
        </div>
        <div class="dev-bom-fy">
          <div class="pagination">
            <span class="total">共 {{ total }} 栋</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import EventBus from '@/event-bus';

export default {
  name: 'ChartBox',
  props: {
    dwList: {
      type: Array,
      default: () => {
        return [
          // {
          //   code: 1,
          //   name: '鸿蒙智慧消防实验室',
          //   yxsc: '926'
          // }
        ];
      }
    },
    activeMonitoringRoom: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      lwzt: '1',
      zxNum: '',
      lxNum: '',
      introduction: {
        jqrjks: {
          style: []
        }
      },
      // 每页数据量
      pageSize: 15,
      // 当前页
      pageCurrent: 1,
      checkBoxSelect: [],
      // 数据总量
      total: 0,
      showGzsbjl: false,
      pageShowName: [{key: 1, value: '东区'},
        {key: 2, value: '西区'},
        {key: 5, value: '中区'},
        {key: 4, value: '南区'},
        {key: 3, value: '北区'}
      ],
      loginUser: sessionStorage.getItem('loginUser'),
      imgTitle: '该单位存在真实或待确认火警情况'
    };
  },
  computed: {
    filterDwList() {
      const _this = this;
      if (!_this.dwList) return [];
      var dataList = JSON.parse(JSON.stringify(_this.dwList));

      // 根据plsx进行分类
      const pageNum = _this.pageCurrent;
      if (pageNum >= 1 && pageNum <= 5) {
        // 过滤出对应plsx的数据
        dataList = dataList.filter(item => {
          // 确保plsx存在且转换为数字进行比较
          const plsxNum = parseInt(item.plsx);
          return !isNaN(plsxNum) && plsxNum === pageNum;
        });
      } else if (pageNum === 6) {
        // 第6页显示其他plsx的数据（plsx为空、不是数字或大于5的）
        dataList = dataList.filter(item => {
          const plsxNum = parseInt(item.plsx);
          return !item.plsx || isNaN(plsxNum) || plsxNum > 5;
        });
      }

      // 设置总数为filterDwList的总长度
      _this.total = _this.dwList.length;

      console.log('按plsx分类后的数据:', dataList);
      console.log('分页号:', pageNum);
      console.log('total:', _this.total);

      return dataList;
    }
  },
  methods: {
    openHjym(dwId) {
      this.$parent.changeDw(dwId);
      this.$parent.handleOHj(dwId);
      // EventBus.$emit('controlShowHj', true, false);
    },
    changeDw(dwId) {
      this.$parent.changeDw(dwId);
    },
    changeJzw(ssdw, dwId) {
      this.$parent.changeJzw(ssdw, dwId);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.checkBoxSelect = [val];
      this.pageCurrent = val;
    },

    handleYjcg() {
      console.log(this.filterDwList.length);
      // EventBus.$emit('DpYjcg');
    },
    handleGzsbjl() {
      console.log('查看故障设备报修记录');
      this.showGzsbjl = !this.showGzsbjl;
      EventBus.$emit('DpGzsbjl');
    },

    /**
     * 从语音文本中提取建筑名称
     * @param {string} text 语音文本
     * @returns {string|null} 提取的建筑名称，如果未提取到则返回null
     */
    extractBuildingName(text) {
      if (!text || typeof text !== 'string') return null;

      // 处理常见的语音命令模式
      const patterns = [
        /查看\s*(.+)/,
        /跳转到\s*(.+)/,
        /跳转\s*(.+)/,
        /进入到\s*(.+)/,
        /进入\s*(.+)/,
        /打开\s*(.+)/
      ];

      // 尝试匹配命令模式
      let extractedName = null;
      for (const pattern of patterns) {
        const match = text.match(pattern);
        if (match && match[1]) {
          extractedName = match[1].trim();
          break;
        }
      }

      if (!extractedName) return null;

      // 清理提取的名称
      extractedName = extractedName
        .replace(/["""''的到这个帮我请]/g, '') // 移除引号和其他干扰字符
        .replace(/楼+$/, '楼') // 确保只有一个"楼"字结尾
        .replace(/室+$/, '室') // 确保只有一个"室"字结尾
        .replace(/区+$/, '区') // 确保只有一个"区"字结尾
        .replace(/厦+$/, '厦') // 确保只有一个"厦"字结尾
        .trim();

      console.log('提取的建筑名称:', extractedName);
      return extractedName;
    },

    /**
     * 在建筑列表中查找最匹配的建筑
     * @param {string} name 要查找的建筑名称
     * @returns {Object|null} 匹配的建筑对象，如果未找到则返回null
     */
    findMatchedBuilding(name) {
      if (!this.dwList || !this.dwList.length || !name) return null;

      console.log(`尝试匹配建筑名称: "${name}"`);

      // 1. 精确匹配 (包括去除空格后的匹配)
      const cleanName = name.replace(/\s+/g, '');
      const exactMatch = this.dwList.find(item => {
        const cleanItemName = item.name.replace(/\s+/g, '');
        return cleanItemName === cleanName;
      });
      if (exactMatch) {
        console.log(`精确匹配成功: ${exactMatch.name}`);
        return exactMatch;
      }

      // 2. 包含匹配
      const containsMatches = this.dwList.filter(item => {
        const cleanItemName = item.name.replace(/\s+/g, '');
        return cleanItemName.includes(cleanName);
      });

      if (containsMatches.length === 1) {
        console.log(`包含匹配成功: ${containsMatches[0].name}`);
        return containsMatches[0];
      }

      console.log(`未找到匹配建筑: "${name}"`);
      return null;
    }
  },
  mounted() {
    // /**
    //  * 语音场景介绍
    //  */
    const _this = this;
    // EventBus.$on('introduction_goto_sys', () => {
    //   //  查找实验室
    //   const sys = _this.dwList.filter(item => item.name.indexOf('物资大厦') > -1);
    //   // 跳转
    //   if (sys.length > 0) {
    //     _this.changeDw(sys[0].botid);
    //   }
    // });
    EventBus.$on('changeJzw', () => {
      //  查找实验室
      const sys = _this.dwList.filter(item => item.name.indexOf('物资大厦') > -1);
      // 跳转
      if (sys.length > 0) {
        _this.changeDw(sys[0].botid);
      }
    });

    EventBus.$on('viewBuilding', function (data) {
      // 处理语音文本，提取建筑名称
      const buildingName = _this.extractBuildingName(data);
      if (buildingName) {
        // 在dwList中查找匹配的建筑
        const matchedBuilding = _this.findMatchedBuilding(buildingName);
        if (matchedBuilding) {
          // 跳转到匹配的建筑
          _this.changeJzw(matchedBuilding.botid, matchedBuilding.code);
          console.log(`已跳转到建筑: ${matchedBuilding.name}`);
        } else {
          console.log(`未找到匹配的建筑: ${buildingName}`);
        }
      }
    });
  },
  created() {
    // const _this = this;
    // EventBus.$on('introductionZt_Left_start', function (data) {
    //   introduceJs.activeElement(_this.introduction, data);
    // });
    // EventBus.$on('introductionZt_Left_stop', function (data) {
    //   introduceJs.clearStyle(_this.introduction);
    // });
  },

  destroyed() {

  }
};
</script>

<style scoped lang="scss">
@import '../monitor.scss';

@import '../../introuduce/introduce.css';

.monitor_center_box-body {
  height: 100%;
  margin-top: 90px;
}

.dev-left-bg {
  width: 362px;
  height: 100%;
  // background: url('/images/newscreen/bg/建筑监控室.png') center center;
}

.dev-title-jks {
  display: flex;
  align-items: center;
  position: relative;
  top: 26px;
  margin: auto;
  width: 329px;
  height: 30px;
  background: url('/monitor/images/tj/left-jks.png');

  &_test{
    margin-top: -7px;

    margin-left: 25px;
    font-family: HYYaKuHei-85J;
    font-weight: 85J;
    font-size: 16px;
    color: #FFFFFF;
  }

}
.dev-onClick{
  color: #3DFBFF !important;
}

.dev-onClick-bg{
  background: url('/monitor/images/tj/left-zx-bg.png') !important;
}
.dev-onClick-jz{
  background: url('/monitor/images/tj/left-jz2.png') !important;
}
.dev-onClick-item {
  opacity: 0.5;
  background-image: linear-gradient(90deg, #4BAFEC 0%, #195796 100%);
}

/* 离线状态样式 */
.dev-offline-item {
  opacity: 0.5;
  filter: grayscale(80%);
  background-image: linear-gradient(270deg, #51515600 0%, #515156c2 35%, #515156c2 70%, #51515600 100%);
}

.dev-zt{
    width: 100%;
    height: 51px;
    z-index: 10;
    display: flex;
    &_zx{
      width: 50%;
      height: 100%;
      font-family: AlibabaPuHuiTi_2_85_Bold;
      font-weight: 700;
      font-size: 16px;

      &_top{
        display: flex;
        align-items: center;
        height: 50%;
        color: #fff;
      }
      &_bom{
        display: flex;
        margin-top: -5px;
        width: 153px;
        height: 28px;
        background: url('/monitor/images/tj/left-zx-bg.png');
      }

  }

  &_lx_bom {
    display: flex;
    margin-top: -5px;
    width: 153px;
    height: 28px;
    background: url('/monitor/images/tj/left-lx-bg.png');
  }
}

.dev-zt-num {
  text-align: center;
  line-height: 24px;
  width: 18px;
  height: 24px;
  background-image: linear-gradient(180deg, hsla(213.1, 100%, 44.1%, 0.1) 0%, hsla(213.3, 100%, 40.6%, 0.49) 100%);
  box-shadow: inset 0 0 2px 1px hsla(211, 100%, 63.5%, 0.38);
  border-radius: 2px;
  margin: 0 3px;
}

.dev-zt-img {
  width: 28px;
  height: 32px;
  margin-left: 20px;
}

.dev-center {
  display: inherit;
  margin-top: 10px;
  max-height: 810px; /* 18条数据 * 45px每条的高度 */
  overflow-y: auto;
  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 175, 255, 0.3);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 175, 255, 0.5);
  }

  &_item {
    height: 45px;
    font-family: AlibabaPuHuiTi_2_55_Regular;
    font-weight: 400;
    font-size: 14px;

    &_body {
      display: flex;
      height: 42px;
      line-height: 53px;
      padding-left: 22px;

      &_img {
        width: 37px;
        height: 45px;
        margin-top: 3px;
      }

      &_img2 {
        width: 32px;
        height: 45px;
        margin-top: 3px;
      }
    }

    &_fire {
      background: url('/images/newscreen/icon/fire.png');
      background-size: 99% 100%;
    }

    &_xhx {
      display: flex;
      height: 1px;
      opacity: 0.4;
      background: #195796;
    }

  }

}

.dev-bom-fy {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 60px;
  right: 18%;
  left: 10%;
}

.dev-top-fy {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 80px;
  right: 3%;
  left: 3%;

  :deep .el-checkbox-group {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  :deep .el-checkbox-button {
    margin: 0 1px;
  }

  :deep .el-checkbox-button__inner {
    background: rgba(26, 49, 90, 0.6) !important;
    padding: 6px 14px !important;
    color: #00AFFF !important;
    border: 1px solid rgba(0, 175, 255, 0.3) !important;
    border-radius: 4px !important;
    transition: all 0.3s ease;
    box-shadow: 0 0 5px rgba(0, 175, 255, 0.1);

    &:hover {
      background: rgba(26, 49, 90, 0.8) !important;
      border-color: rgba(0, 175, 255, 0.6) !important;
      box-shadow: 0 0 8px rgba(0, 175, 255, 0.3);
    }
  }

  :deep .checkBoxSelected1 {
    .el-checkbox-button__inner {
      background: linear-gradient(90deg, rgba(75, 175, 236, 0.7), rgba(25, 87, 150, 0.7)) !important;
      border-color: #00AFFF !important;
      color: #FFFFFF !important;
      box-shadow: 0 0 10px rgba(0, 175, 255, 0.4);
    }
  }
}

.dev-bom-fy, .dev-top-fy {
  .pagination {
    display: flex;
    align-items: center;
    gap: 10px;

    .total {
      font-family: SourceHanSansSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #00AFFF;
    }

    .btn-prev,
    .btn-next {
      background: #1A1311;
      width: 16px;
      height: 16px;
      opacity: 0.36;
      border: 1px solid #00AFFF;
      border-radius: 2px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:disabled {
        opacity: 0.2;
        cursor: not-allowed;
      }

      .arrow {
        border: solid #00AFFF;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;

        &.left {
          transform: rotate(135deg);
        }

        &.right {
          transform: rotate(-45deg);
        }
      }
    }

    .pager {
      display: flex;
      gap: 5px;
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        font-size: 14px;
        color: #fff;
        background: #001334;
        min-width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 2px;

        &.active {
          color: #00AFFF;
          opacity: 0.36;
          border: 1px solid #00AFFF;
          background: #0d1424;
        }
      }
    }
  }
}

.dev-yjcg {
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 103px;
  position: absolute;
  right: 0px;
  top: -10px;
  border: 1px solid #03A9F4;
  text-align: center;
  line-height: 32px;

  border-radius: 4px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: 700;
  font-size: 14px;
  background: #002F72;
  -webkit-box-shadow: inset 0 0 8px 0 #0066ff80;
  box-shadow: inset 0 0 8px 0 #00D1FE;
  color: #ffff;

}

.dev-yjcg:hover {
  // border: 1px solid #48ff00;
  border: 1px solid #eaece9;
}

.dev-cg-img {
  width: 24px;
  height: 24px;
  margin: 0 5px;
}

.hjlb-item-huozai {
  width: 24px;
  height: 20px;
  position: absolute;
  margin: auto;
  top: 0;
  left: 150px;
  right: 0;
  bottom: 0;
}

.div-gzsb-jl {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-top: 100px;
  height: 33px;
  background-color: #153e88;
  color: #fff;
  width: 180px;
  border-radius: 5px;
}
</style>
